import { connect } from 'react-redux';
import decorate from 'src/utils/decorate';
import { request } from 'src/modules/user/actions/logout';
import incjetPermissions from 'src/utils/permissionsInject';

import { Header } from './Header';

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onLogoutRequest: () => dispatch(request())
    };
}

// eslint-disable-next-line import/no-default-export
export default decorate(
    connect(incjetPermissions(mapStateToProps), mapDispatchToProps),
    Header
);
